import { API } from "apis";
import PageTitle from "components/common/PageTitle";
import MessageInputArea from "components/thread/detail/MessageInputArea";
import MessageItem from "components/thread/detail/MessageItem";
import { ContextModel, ThreadMessageSearchAPIResultModel } from "models";
import { CommonFileModel } from "models/CommonFileModel";
import React from "react";
import { Helmet } from "react-helmet-async";
import { useOutletContext, useParams } from "react-router-dom";
import { Utils } from "utils";

const ThreadDetailPage: React.FC = () => {
  const params = useParams();

  const ctx = useOutletContext<ContextModel>();
  const didEffect = React.useRef(false);

  const commentArea = React.useRef<HTMLDivElement>(null);
  const [data, setData] = React.useState<ThreadMessageSearchAPIResultModel>();
  const [completed, setCompleted] = React.useState(false);

  const threadId = params.id ?? "";

  const load = async (threadId: string) => {
    try {
      const response = await API.ThreadMessage.search(threadId);
      console.log(response);
      setData(response.data);

      setCompleted(response.data.thread.thread_status === 1);
    } catch (err) {
      Utils.errorAction(ctx, err);
    }
  };

  // 「お問い合わせ終了」
  const onComplete = async () => {
    ctx.loading.setState(true);
    try {
      const response = await API.Thread.update(threadId, 1, 1);
      console.log(response);

      await load(threadId);
      setCompleted(true);
    } catch (err) {
      Utils.errorAction(ctx, err);
    }
    ctx.loading.setState(false);
  };

  // メッセージ送信
  const onSend = async (message: string, files: CommonFileModel[]) => {
    ctx.loading.setState(true);
    try {
      const response = await API.ThreadMessage.create(threadId, message, files);
      console.log(response);

      await load(threadId);
      ctx.loading.setState(false);
      return true;
    } catch (err) {
      Utils.errorAction(ctx, err);
      ctx.loading.setState(false);
      return false;
    }
  };

  React.useEffect(() => {
    if (didEffect.current) {
      return;
    }
    didEffect.current = true;
    const f = async () => {
      await ctx.auth.initialize();
      await ctx.limitPrice.load();

      await load(threadId);
      ctx.loading.setState(false);
    };
    f();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const div = commentArea.current!;
    div.scrollTo({ top: div.scrollHeight - div.clientHeight, left: 0 });
  }, [data]);

  return (
    <div className="h-full flex flex-col justify-start overflow-y-auto">
      <Helmet>
        <title>見積依頼・お問い合わせ詳細</title>
      </Helmet>
      <PageTitle title="見積依頼・お問い合わせ詳細" className="p-2" />

      <div className="m-2 p-2 flex justify-between items-center border-y">
        <div className="font-bold text-2xl">{data?.thread.corp_name}</div>
        {ctx.auth.data?.is_admin_corp === true ? (
          <div className="py-2">&nbsp;</div>
        ) : (
          <button
            className="secondary px-4 py-2"
            onClick={onComplete}
            disabled={completed}
          >
            お問い合わせ終了
          </button>
        )}
      </div>

      <div className="flex-1 overflow-y-scroll" ref={commentArea}>
        {data?.message_list.map((item, index) => {
          return (
            <MessageItem
              key={index}
              ctx={ctx}
              opponentCorpId={data.thread.corp_id}
              data={item}
            />
          );
        })}
      </div>

      {!completed && !ctx.auth.data?.is_admin_corp && (
        <MessageInputArea ctx={ctx} onSend={onSend} />
      )}
    </div>
  );
};
export default ThreadDetailPage;
